import React from "react";
import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

interface LabelWithTooltipProps {
	label: string;
	tooltip: string;
}

const LabelWithTooltip: React.FC<LabelWithTooltipProps> = ({ label, tooltip }) => (
	<span>
		{label}{" "}
		<Tooltip title={tooltip}>
			<InfoCircleOutlined style={{ color: "#1890ff" }} />
		</Tooltip>
	</span>
);

export default LabelWithTooltip;
